import { useQuery } from '@tanstack/react-query';
import { useRestClient } from '../../api/RestClientContext';

export function useCheckSubscription(enabled = true) {
	const client = useRestClient();

	const query = useQuery({
		queryKey: ['subscription'],
		queryFn: client.checkSubscription,
		retry: false,
		enabled,
	});

	return {
		subscription: query.data,
		isLoading: query.isLoading,
		error: query.error,
		refetch: query.refetch,
	};
}